// U32b — kiểu prompt RIÊNG của một video (THUẦN; tách khỏi promptVideoUtils để WorkflowPromptStep không kéo cả cây clip/storyboard vào).
import type { FilmPromptMode, PromptModeState } from '../../types/film';
import { MODE_LABEL_VI, promptModeStateOf, resolvePromptMode, snapshotModeOf } from './promptModeUtils';

export interface PromptModeView {
  /** Giá trị ô chọn «Theo plan / Tự nhiên / Kỹ thuật». */
  selectValue: 'PLAN' | FilmPromptMode;
  effectiveLabel: string;
  /** Kiểu của chữ ĐANG LƯU (null khi chưa có prompt). */
  snapshotLabel: string | null;
  state: PromptModeState;
  /** MỘT dòng nói rõ tình trạng kiểu. */
  line: string;
  /** Nhãn nút tạo lại theo kiểu mới (null khi prompt đã khớp). */
  rebuildLabel: string | null;
  /** Tạo lại sẽ ghi đè bản sửa tay (EDITED + lệch kiểu). */
  willOverwriteEdit: boolean;
}
/**
 * Kiểu prompt riêng của MỘT video — cùng logic `promptModeUtils` (mirror BE) mà EventPlanTab dùng: kiểu hiệu lực = đè riêng ?? kiểu của plan; so với kiểu của chữ đang lưu.
 * Lệch ⇒ nói rõ prompt đang ở kiểu cũ + nút «Tạo lại prompt theo kiểu mới» (đường tạo lại prompt per-event có sẵn).
 */
export function promptModeViewOf(
  ev: { promptMode?: FilmPromptMode | null; authorPrompt?: string | null; authorPromptMode?: FilmPromptMode | null; authorStatus?: string | null },
  planMode: unknown,
): PromptModeView {
  const effective = resolvePromptMode(ev.promptMode, planMode);
  const state = promptModeStateOf({ effectiveMode: effective, authorPrompt: ev.authorPrompt, authorPromptMode: ev.authorPromptMode });
  const snap = snapshotModeOf(ev.authorPrompt, ev.authorPromptMode);
  const selectValue: PromptModeView['selectValue'] = ev.promptMode === 'NATURAL' || ev.promptMode === 'TECHNICAL' ? ev.promptMode : 'PLAN';
  const effectiveLabel = MODE_LABEL_VI[effective];
  const snapshotLabel = snap ? MODE_LABEL_VI[snap] : null;
  if (state === 'MISSING') return { selectValue, effectiveLabel, snapshotLabel: null, state, line: `Chưa có prompt — sẽ tạo theo kiểu ${effectiveLabel}.`, rebuildLabel: 'Tạo prompt', willOverwriteEdit: false };
  if (state === 'MISMATCH') {
    return { selectValue, effectiveLabel, snapshotLabel, state, line: `Prompt đang lưu ở kiểu ${snapshotLabel}, video đang ở kiểu ${effectiveLabel}.`, rebuildLabel: 'Tạo lại prompt theo kiểu mới', willOverwriteEdit: ev.authorStatus === 'EDITED' };
  }
  return { selectValue, effectiveLabel, snapshotLabel, state, line: `Kiểu ${effectiveLabel} — prompt khớp kiểu.`, rebuildLabel: null, willOverwriteEdit: false };
}
